import { type Question } from '@/types'

import { generateId } from '../utils'
import { findMatrixRowByQuestionIdAndRowOrder } from './findMatrixRowByQuestionIdAndRowOrder'
import { getMatrixRowPosition } from './getMatrixRowPosition'
import { truncateText } from './truncateText'

export const getMatrixRowQuestionInfoByRowOrder = (
  questions: Question[],
  questionId: number,
  rowOrder: number
) => {
  const matrixRow = findMatrixRowByQuestionIdAndRowOrder(
    questions,
    questionId,
    rowOrder
  )

  const position = getMatrixRowPosition(
    questions,
    String(matrixRow?.form_index) || ''
  )

  const defaultTitle = 'Removed'
  const title = matrixRow?.text || defaultTitle
  const description = [position, title].join(' ')
  return {
    classes: matrixRow ? '' : 'removed',
    description,
    id: generateId(),
    title: truncateText(description),
  }
}
